import { z } from "zod";

export type UserRole = "clientUser" | "clientAdmin" | "systemAdmin";

export const UserRoleSchema = z.enum(["clientUser", "clientAdmin", "systemAdmin"]);

export type TUserRole = UserRole;

export type TAccessMode = "read" | "edit";

export const AccessModeSchema = z.enum(["read", "edit"]);

export const CreateUserSchema = z.object({
  email: z.string().email(),
  role: UserRoleSchema,
  organizationId: z.number().optional()
});

export const UpdateUserRoleSchema = z.object({
  role: UserRoleSchema
});

export type TCreateUser = z.infer<typeof CreateUserSchema>;
export type TUpdateUserRole = z.infer<typeof UpdateUserRoleSchema>;

// TODO: When junction table is implemented, User interface will include user-org relationships
// allowing for different roles per organization (e.g., user.organizationRoles[orgId].role)
export type TUser = {
  role: UserRole;
  accessMode?: TAccessMode;
  organizationId: number;
};
